/**
 * Pide una familia a Google Fonts una sola vez por documento.
 *
 * La usan Brand Studio (para previsualizar la tipografía del kit) y la galería
 * de marcas (para pintar cada nombre con la suya). El runtime de Xurvey tiene
 * su propio cargador (`renderer/theme/fonts.ts`): es otra app y otro documento.
 */
export function loadGoogleFont(name: string | null | undefined): void {
  if (!name || typeof document === 'undefined') return;
  const id = `gfont-${name.replace(/\s+/g, '-')}`;
  if (document.getElementById(id)) return;
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(name)}:wght@400;600;700&display=swap`;
  document.head.appendChild(link);
}
